import Cookies from "js-cookie"

export const cookies = Cookies
